import React, { useState, useCallback, useEffect } from "react";
import styles from "./index.module.scss";

const Page4 = ({ scrollToAnchor }) => {
	return (
		<div className={styles.page}>
			<div className={styles.text}>課間進階式問答法</div>
			<div className={styles.text2}>
				<div className={styles.message}>
					觀察與研討得證，有效提升學習成效
				</div>
			</div>
			<div className={styles.bg2}>
				<div className={styles.imgContent}>
					<img src={"./assets/img/進階式問答.jpg"} alt="bg" />
				</div>
			</div>
		</div>
	);
};
export default Page4;
